export default __webpack_public_path__ + "static/media/crodudes_group.51c116da.png";